export const brooksofyork = [
	{
		"id": 1,
		"jump": "brooksofyork",
		"title": "",
		"pic": "../img/brooksofyork/iphones.jpg",
		"alt": "iPhone mockup screens of Brooks of York on Spotify",
		"center": "imagewide"
	},
	{
		"id": 2,
		"jump": "brooksofyork1",
		"title": "'I Got The Moon'",
		"desc": "Digital Single Art",
		"pic": "../img/brooksofyork/igotthemoon.jpg",
		"alt": "I got the moon, digital single artwork",
		"center": "imagewide spacing1"
	},
	{
		"id": 3,
		"jump": "brooksofyork2",
		"title": "'To Giants (Light Show Remix)'",
		"desc": "Digital Single Art",
		"pic": "../img/brooksofyork/to-giants.jpg",
		"alt": "To giants light show remix, Digital Single Artwork",
		"center": "imagewide spacing1"
	},
]